module.exports = __webpack_public_path__ + "img/img_wacca_sp.e9435219.png";